// extracted by mini-css-extract-plugin
export var md = "_3v-4";
export var semantic = "_3v-5";
export var sm = "_3v-3";
export var text = "_3v-6";
export var toggleInput = "_3v-0";
export var toggleSwitch = "_3v-1";
export var xs = "_3v-2";